import React,{useRef, useEffect, useState} from 'react'
import {Checkbox, Icon} from 'selfly-ui-react'

const MultiSelect =({locations, selectedLocations, locationChange})=>{
    const componentRef = useRef(null)
    const componentOnFocus = useComponentOnFocus(componentRef);
    const [isOpen, setIsOpen] = useState(false)

    const toggleMultiSelect =()=>{
        setIsOpen(!isOpen)
    }

    const onSelectionChange =(event, code)=>{       
        if(event){
            const locations = selectedLocations ? [...selectedLocations, code] : [code]
            locationChange(locations)
        }else{
            const locations = selectedLocations ? [...selectedLocations] : []
            const index = locations.indexOf(code)
            if(index !== -1){
                locations.splice(index, 1)
            }
            locationChange(locations)
        }
    }

    return (
        <div className="multi-select" ref={componentRef}>
            <div className="multi-select__label" onClick={toggleMultiSelect}>
                <span className="multi-select__label-text">
                    {selectedLocations && selectedLocations.length ? selectedLocations.length : 'None'} selected
                </span>
                <span className="multi-select__label-icon">
                    <Icon>keyboard_arrow_down</Icon>
                </span>
            </div>
            <div
                className={`multi-select__container ${isOpen && componentOnFocus ? 'multi-select__container--open':''}`}
            >
                <ul className="multi-select__options">
                    {locations.map(location => {
                        return (
                            <li className="muli-select__options-list" key={location.code}>
                                <Checkbox
                                    id={location.code}
                                    name="text"
                                    size="md"
                                    onChange={event => {
                                        onSelectionChange(event.target.checked, location.code);
                                    }}
                                    checked={selectedLocations && selectedLocations.includes(location.code)}
                                >
                                    {location.name}
                                </Checkbox>
                            </li>
                        );
                    })}
                </ul>
            </div>
        </div>
    );
};

/*
 * Component to check if mouse click
 * is outside dropedown component
 */
const useComponentOnFocus = ref => {
    const [focus, setFocus] = useState(false);
    useEffect(() => {
        const handleClickOutside = event => {
            if (ref.current && !ref.current.contains(event.target)) {
                setFocus(false);
            } else {
                setFocus(true);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
    }, [ref]);
    return focus;
};

export default MultiSelect